import { store } from '@core/Store'
import { setBetSlipIsOpen } from '@core/Areas/AppHeader/Store'
import { showLogin as showLoginHelper } from '@core/Areas/Login/helpers'
import { openShareOutgoing } from '@core/Areas/ShareBet/ShareBetOutgoing/helpers/emitter'
import type { BetSlipShare } from '@core/Areas/ShareBet/types'

export const toggleBetSlipDrawer = (isOpen: boolean) => store.dispatch(setBetSlipIsOpen(isOpen))

export const showLogin = () => {
  showLoginHelper({
    onLoginSuccessCallback: () => {
      store.dispatch(setBetSlipIsOpen(true))
    },
  })
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

export const handleShareBet = (share: BetSlipShare['share']) =>
  openShareOutgoing({ contextType: 'betslip', share })
